import { Content } from "./styles"

export function Description() {
  return (
    <Content>
      <h1>We are launching <strong>soon!</strong></h1>
      <span>Subscribe and get notified</span>
    </Content>
  )
}